<template>
  <div class="schedule-page">
    <div class="container">
      <Toolbar class="mb-5" title-tag="h1">
        <template #title>
          Расписание
        </template>
      </Toolbar>

      <!-- <ScheduleCity v-for="(city, index) in cities" :key="index" :city="city">
      </ScheduleCity> -->

      <ScheduleFinal />
      <!-- <ScheduleSoon /> -->
    </div>
  </div>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar/";
// import ScheduleCity from "@/components/schedule/ScheduleCity";
import ScheduleFinal from "./ScheduleFinal";
// import ScheduleSoon from "./ScheduleSoon";
import { mapState, mapActions } from "vuex";

export default {
  name: "SchedulePage",
  components: {
    Toolbar,
    // ScheduleCity,
    ScheduleFinal
    // ScheduleSoon
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapState("dictionaries", {
      cities: ({ dictionaries }) => dictionaries.cities || new Array(3)
    })
  },
  created() {
    if (!this.cities[0]) {
      this.getDictionary("cities");
    }
  },
  methods: {
    ...mapActions("dictionaries", ["getDictionary"])
  },
  breadcrumb: {
    title: "Расписание",
    to: "/schedule"
  }
};
</script>

<style lang="scss">
.schedule-page {
  &__btn {
    height: 50px;
    text-transform: uppercase;
    width: 220px;
    margin-left: auto;
  }

  @include breakpoint("sm-and-down") {
    &__btn {
      margin-right: auto;
    }
  }
}
</style>
